export default "__VITE_ASSET__076c039f__"